/**
 * The order a new project starts in, once the operator has chosen its
 * workflow in the New project chooser.
 *
 * The chosen mode is applied LAST, after `then`. From the Run Sheet and
 * Project History, `then` is `handleNavigate('quotemaker')`, a closure made
 * before this reset. With nothing open it takes the no-active-work fast path
 * and calls `resetForm()` again, and `resetForm()` sets the mode to Full AI.
 * Applied before `then`, the operator's Fast-Track choice was overwritten in
 * the same batch and the project started as Full AI (2026-10-21 live checks).
 * Applied after it, the choice is the last write whatever `then` resets.
 */
export interface StartNewProjectSteps {
    resetEditor?: () => void;
    resetForm: () => void;
    applyWorkflowMode: () => void;
    then?: () => void;
}

export function startNewProjectWithChosenWorkflow({ resetEditor, resetForm, applyWorkflowMode, then }: StartNewProjectSteps): void {
    resetEditor?.();
    resetForm();
    then?.();
    applyWorkflowMode();
}
